import { render, staticRenderFns } from "./reservation-studio.vue?vue&type=template&id=70a4b899&scoped=true&"
import script from "./reservation-studio.vue?vue&type=script&lang=js&"
export * from "./reservation-studio.vue?vue&type=script&lang=js&"
import style0 from "./reservation-studio.vue?vue&type=style&index=0&id=70a4b899&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4b899",
  null
  
)

export default component.exports